<template>
	<div style="padding: 20px 20px 20px 0;">
		<div>
			<el-form :inline="true" :model="selectForm" ref="selectForm">
				<el-form-item label="楼栋" prop="building">
					<el-input size="small" v-model="selectForm.building" placeholder="请输入楼栋" clearable></el-input>
				</el-form-item>
				<el-form-item label="楼层" prop="floor ">
					<el-input size="small" v-model="selectForm.floor" placeholder="请输入楼层" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="getAll" size="small">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button size="small" type="primary" @click="query();">重置</el-button>
				</el-form-item>
				<el-form-item>
					<el-button size="small" type="primary" @click="dc()">导出</el-button>
				</el-form-item>
				<el-form-item>
					<el-button size="small" type="primary" @click="goAdd">新增</el-button>
				</el-form-item>
	
			</el-form>
		</div>
		<el-table :data="data" style="width: 100%" v-loading="loading">
			<el-table-column prop="building" label="楼栋" align="center"></el-table-column>
			<el-table-column prop="floor" label="楼层" align="center"></el-table-column>
			<el-table-column prop="location" label="位置" align="center"></el-table-column>
			<el-table-column prop="sfState" label="送风状态" align="center"></el-table-column>
			<el-table-column prop="hfState" label="回风状态" align="center"></el-table-column>
			<el-table-column prop="hfMalfunction" label="送风故障" align="center"></el-table-column>
			<el-table-column prop="temperature" label="温度" align="center"></el-table-column>
		</el-table>
		<!-- 搜索条件 -->


		<!-- 分页 -->
		<el-pagination v-if="totalNum > 0" @size-change="sizeChange" @current-change="currentChange"
			:page-sizes="[10, 20, 30, 40]" :page-size="selectForm.rows" layout="total, sizes, prev, pager, next, jumper"
			:total="totalNum" style="margin-top: 10px;">
		</el-pagination>

		<el-dialog title="BA设备录入" :visible.sync="show" width="40%" @close="closeShow">
			<el-form :model="formInline" class="demo-form-inline" ref="formInline" :rules="rules">
				<el-row>
					<el-col  :span="11">
						<el-form-item prop="building" label="楼栋" label-width="80px">
							<el-input v-model="formInline.building" placeholder="请输入楼栋"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item prop="floor" label="楼层" label-width="80px">
							<el-input v-model="formInline.floor" placeholder="请输入楼层"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="11">
						<el-form-item prop="locationNum" label="位置编码" label-width="80px">
							<el-input v-model="formInline.locationNum" placeholder="请输入位置编码"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item prop="location" label="位置" label-width="80px">
							<el-input v-model="formInline.location" placeholder="请输入位置"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
                <el-row>
					<el-col :span="11">
						<el-form-item prop="sfStateNumber" label="送风状态编码" label-width="80px">
							<el-input v-model="formInline.sfStateNumber" placeholder="请输入送风状态编码"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item prop="hfStateNumber" label="回风状态编码" label-width="80px">
							<el-input v-model="formInline.hfStateNumber" placeholder="请输入回风状态编码"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
                <el-row>
					<el-col :span="11">
						<el-form-item prop="hfMalfunctionNumber" label="送风故障编码" label-width="80px">
							<el-input v-model="formInline.hfMalfunctionNumber" placeholder="请输入送风故障编码"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="11">
						<el-form-item prop="temperatureNumber" label="温度编码" label-width="80px">
							<el-input v-model="formInline.temperatureNumber" placeholder="请输入温度编码"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="closeShow">取 消</el-button>
				<el-button type="primary" @click="ok">确定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import publicExport from "../../../assets/js/publicExport.js";
export default {
  data() {
    return {
      loading: false,
      queryDate: [],
      sfRoom: null,
      count: null,
      sum: null,
      headerData: {
        Authorization: localStorage.access_token,
      },
      rules: {
        building: [
          {
            required: true,
            message: "不能为空",
            trigger: ["blur", "change"],
          },
        ],
        floor: [
          {
            required: true,
            message: "不能为空",
            trigger: ["blur", "change"],
          },
        ],
        locationNum: [
          {
            required: true,
            message: "不能为空",
            trigger: ["blur", "change"],
          },
        ],
        location: [
          {
            required: true,
            message: "不能为空",
            trigger: ["blur", "change"],
          },
        ],
        sfStateNumber: [
          {
            required: true,
            message: "不能为空",
            trigger: ["blur", "change"],
          },
        ],
        hfStateNumber: [
          {
            required: true,
            message: "不能为空",
            trigger: ["blur", "change"],
          },
        ],
        hfMalfunctionNumber: [
          {
            required: true,
            message: "不能为空",
            trigger: ["blur", "change"],
          },
        ],
        temperatureNumber: [
          {
            required: true,
            message: "不能为空",
            trigger: ["blur", "change"],
          },
        ],
        
      },
      oldFormInline: {},
      data: [], //表格数据
      selectForm: {
        //查询条件
        page: 1, //当前页
        rows: 10, //页大小
        building: "",
        floor: "",
      },
      formInline: {
        building: "", //楼栋
        floor: "", //楼层
        locationNum: "", //位置编码
        location: "", //位置
        sfState: "", //送风状态
        hfState: "", //回风状态
        hfMalfunction: "", //送风故障
        temperature: "", //温度
      },
      totalNum: 0, //数据总数
      show: false, //控制弹窗

      title: "",
      disable: false, //节流
    };
  },
  methods: {
    closeShow() {
      this.$refs["formInline"].resetFields();
      this.show = false;
    },
    dc() {
      publicExport("/api/energy/exportBA", this.selectForm, "BA数据");
    },

    goAdd() {
      this.show = true;
      this.title = "新增";
      this.formInline = JSON.parse(JSON.stringify(this.oldFormInline));
    },
    ok() {
      this.$refs.formInline.validate((valid) => {
        if (valid) {
          let url = "/api/energy/insertBA";
          this.$http
            .post(url, {
              ...this.formInline,
            })
            .then((res) => {
              this.show = false;
              this.$message.success(res.data.message);
              this.getAll();
              console.log(res);
            });
        } else {
          return;
        }
      });
      return;
    },
    getAll() {
      this.loading = true;
      this.$http
        .post(`/api/energy/queryBA`, {
          ...this.selectForm,
        })
        .then((res) => {
          this.loading = false;
            if (res.data.code == 0) {
            this.data = res.data.data.items;
            this.totalNum = res.data.data.totalNum;
            this.count = this.totalNum;
          } else {
            this.data = [];
            this.totalNum = 0;
            this.count = 0;
            this.sum = 0;
            this.$message.error(res.data.message);
          }
        });
      
    },
    query() {
      this.selectForm = {
        //查询条件
        page: 1, //当前页
        rows: 10, //页大小
        building: "",
        floor: "",
      };
      this.getAll();
    },
    sizeChange(size) {
      //页大小被修改
      this.selectForm.rows = size;
      this.getAll();
    },
    currentChange(page) {
      //当前页被修改
      this.selectForm.page = page;
      this.getAll();
    },
  },
  mounted() {
    this.oldFormInline = JSON.parse(JSON.stringify(this.formInline));
    this.getAll();
    // this.setMonth();
  },
};
</script>

<style>
</style>
